import React from 'react';

import './index.scss';

// eslint-disable-next-line react/prop-types
export default function OverlineSmall({ children }) {
  return (
    <div className="overline-small">{ children }</div>
  );
}
